// https://admin.caerussolutions.com/?Action=CustomStatView&Parameter=REGISTRY/117#LANG_ID=36

export const criteriaIds = {
  accomodation: 16,
  bloodType: 53,
  breastSize: 21,
  build: 1,
  caste: 31,
  children: 25,
  countryOfOrigin: 52,
  dietaryPractice: 50,
  diet: 50,
  domination: 46,
  drinking: 12,
  education: 18,
  endowment: 20,
  ethnicity: 3,
  eyeColour: 32,
  facialHair: 48,
  favoriteMusicGenre: 62,
  favoriteSport: 51,
  geekInterest: 58,
  hairColour: 33,
  hairLength: 45,
  height: 13,
  interests: { adult: 42, dating: 23 },
  languages: 8,
  lookingFor: { adult: 27, dating: 15 },
  maritalStatus: 9,
  religion: 11,
  muslimValues: 63,
  occupation: 10,
  sexualPreference: 2,
  smoking: 49,
  yearlyIncome: 41,
}

const relevantCriteria = ({ male, female, adult }) =>
  [
    'build',
    'ethnicity',
    'eyeColour',
    ...(male ? ['facialHair'] : []), // on HSB & AC
    'hairColour',
    'hairLength',
    'height',
    ...(adult && female ? ['breastSize'] : []),
    // ...(male ? ['endowment'] : []), // on HSB & AC
    'education',
    'maritalStatus',
    ...(!adult ? ['children', 'religion'] : []),
    'smoking',
    'drinking',
    'yearlyIncome',
    ...(adult ? ['domination', 'accomodation'] : []),
  ].map(name => criteriaIds[name])

export const searchCriteria = relevantCriteria({ female: true })

export const userCriteria = ({ member = {} }, adult) =>
  relevantCriteria({
    male: member.sexOfMemberId == 1,
    female: member.sexOfMemberId == 2,
    adult,
  })

export const criteriaName = (id, { criteria }) => criteria.find(e => e.id === id)?.name

export const criteriaOptions = (id, { criteriaItems }) => criteriaItems.filter(item => item.parentCriterionId === id)
